import { render } from "./InspectorSidebar.vue?vue&type=template&id=543828d4&scoped=true"
import script from "./InspectorSidebar.vue?vue&type=script&lang=js"
export * from "./InspectorSidebar.vue?vue&type=script&lang=js"

import "./InspectorSidebar.vue?vue&type=style&index=0&id=543828d4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543828d4"]])

export default __exports__